/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const WorkExperienceType = {
    Work: 'Work',
    Internship: 'Internship',
    Volunteer: 'Volunteer'
};
export function instanceOfWorkExperienceType(value) {
    for (const key in WorkExperienceType) {
        if (Object.prototype.hasOwnProperty.call(WorkExperienceType, key)) {
            if (WorkExperienceType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function WorkExperienceTypeFromJSON(json) {
    return WorkExperienceTypeFromJSONTyped(json, false);
}
export function WorkExperienceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function WorkExperienceTypeToJSON(value) {
    return value;
}
export function WorkExperienceTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
